import get from 'lodash/get';
import React, { Fragment } from 'react';
import {
  Button, Typography,
} from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';
import { TimePicker } from 'material-ui-pickers';
import PropTypes from 'prop-types';
import alarmIcon from '../../assets/img/alarm.png';
import moment from 'moment';
import { days } from '../../data/Constants';
import { resourceFormStyle } from '../../css/style';
import ToolTip from './ToolTip';
import { isDeviceView, translation } from '../../utils/Functions';
import * as TimeLimitUtils from '../../utils/TimeLimitUtils';

const styles = resourceFormStyle();
const daysOfWeekErrorText = translation('Categories.TimeLimits.daysOfWeekError');
const startIsMissingText = translation('Categories.TimeLimits.startTimeError');
const endIsMissingText = translation('Categories.TimeLimits.endTimeError');
const endIsBeforeStartErrorText = translation('Categories.TimeLimits.endIsBeforeStartError');

const DeleteIcon = ({ onDelete }) => (
  <svg onClick={() => onDelete()} xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '5%', cursor: 'pointer' }} width="24" height="24" viewBox="0 0 24 24">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

const TimeLimit = (props) => {
  const {
    timeLimitSwitch,
    daysButtonStates,
    onDaysButtonChange,
    timeLimitData,
    onTimePickerChange,
    resources,
    field,
    areTimeLimitSubfieldsValid,
    onDelete,
    onAddAnother,
    isOnlyTimeLimit,
  } = props;
  const startEndTimeProps = { timeLimitData, onTimePickerChange, areTimeLimitSubfieldsValid };
  const { hasDaysInWeek } = areTimeLimitSubfieldsValid;
  const timeLimitContainerWithHeightForErrorsStyle = isDeviceView('md', props.width)
    ? { ...styles.timeLimitContainerWithHeightForErrors, ...styles.baseTimeLimitContainerMobile }
    : styles.timeLimitContainerWithHeightForErrors;
  return (
      <div style={timeLimitContainerWithHeightForErrorsStyle}>
        {
          timeLimitSwitch
          && (
            <div>
              {
                days.map((item, index) => (
                  <Button
                    key={item.key}
                    variant="contained"
                    size="small"
                    style={{
                      ...styles.daysButton,
                      ...(daysButtonStates[index] && styles.daysButtonSelected),
                    }}
                    onClick={() => onDaysButtonChange(index)}
                  >
                    {item.title}
                  </Button>
                ))
              }
              {!hasDaysInWeek && daysOfWeekError()}
            </div>
          )
        }
        <div style={styles.timePickersAndButtonsContainer}>
          {
            timeLimitSwitch
            && (
              <StartEndTime
                {...startEndTimeProps}
              />
            )
          }
          {
            timeLimitSwitch
            && (
              <div style={styles.deleteAddAnotherContainer}>
                {!isOnlyTimeLimit && (
                  <DeleteIcon
                    onDelete={() => onDelete()}
                  />
                )}
                <Typography
                  style={styles.addTimeLimitLink}
                  onClick={() => onAddAnother()}
                >
                  add another
                </Typography>
              </div>
            )
          }
        </div>
      </div>
  );
};

export const StartEndTime = (props) => {
  const { timeLimitData, onTimePickerChange, areTimeLimitSubfieldsValid } = props;

  const start = get(timeLimitData, 'start', null);
  const startValue = moment(start, TimeLimitUtils.formatsToTryParsing);
  const startErrorText = getStartEndErrorText('start', areTimeLimitSubfieldsValid);

  const end = get(timeLimitData, 'end', null);
  const endValue = moment(end, TimeLimitUtils.formatsToTryParsing);
  const endErrorText = getStartEndErrorText('end', areTimeLimitSubfieldsValid);

  return (
    <div style={styles.imgAndTimePicker}>
      <img src={alarmIcon} style={styles.alarmImg} alt="alarm" />
      <div style={styles.collapsedTimePickerAndErrorContainer}>
        <TimePicker
          style={styles.timePickerStyle}
          InputProps={styles.timePickerInputProp}
          minutesStep={5}
          value={startValue}
          onChange={val => onTimePickerChange(val, 'start')}
        />
        {startEndTimeError(startErrorText)}
      </div>
      <div style={styles.dashBetweenTimePicker}> - </div>
      <div style={styles.collapsedTimePickerAndErrorContainer}>
        <TimePicker
          style={styles.timePickerStyle}
          InputProps={styles.timePickerInputProp}
          minutesStep={5}
          value={endValue}
          onChange={val => onTimePickerChange(val, 'end')}
        />
        {startEndTimeError(endErrorText)}
      </div>
    </div>
  );
};

StartEndTime.displayName = 'StartEndTime';

const startEndTimeErrors = {
  start: startIsMissingText,
  end: endIsMissingText,
};
const getStartEndErrorText = (startOrEnd, areTimeLimitSubfieldsValid) => {
  const { isStartATimeString, isEndATimeString, isStartBeforeEnd } = areTimeLimitSubfieldsValid;
  if (!isStartBeforeEnd && isStartATimeString && isEndATimeString) return endIsBeforeStartErrorText;
  const startIsEmpty = startOrEnd === 'start' && !isStartATimeString;
  const endIsEmpty = startOrEnd === 'end' && !isEndATimeString;

  if (startIsEmpty || endIsEmpty) return startEndTimeErrors[startOrEnd];
  return '';
};

const daysOfWeekError = () => (
  <div style={styles.dayOfWeekErrorDiv}>
    <p style={styles.timeLimitErrorText}>{daysOfWeekErrorText}</p>
  </div>
);


const startEndTimeError = error => (
  <div style={styles.startEndTimeErrorDiv}>
    <p style={styles.timeLimitErrorText}>{error}</p>
  </div>
);

TimeLimit.propTypes = {
  timeLimitSwitch: PropTypes.bool,
  daysButtonStates: PropTypes.array,
  onDaysButtonChange: PropTypes.func,
  timeLimitData: PropTypes.array,
  onTimePickerChange: PropTypes.func,
  areTimeLimitSubfieldsValid: PropTypes.objectOf(PropTypes.bool),
  onDelete: PropTypes.func,
  onAddAnother: PropTypes.func,
  isOnlyTimeLimit: PropTypes.bool,
};
export { TimeLimit as TimeLimitTest };
export default withWidth()(TimeLimit);
